'use client';

import React, { type CSSProperties, useState } from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';

import { EmailMagicLinkButton } from '../components/EmailMagicLinkButton';

import styles from './styles.module.css';

import { Divider } from '@/components/OrDivider';
import { SocialLogin } from '@/components/SocialLogin';
import {
  type AccountLinkingCredential,
  MagicLinkType,
} from '@/modules/login/types';
import { useGetInitialError } from '@/modules/login/useGetInitialError';

export type Props = {
  nonce?: string;
  storedAccountLinkingCredential?: AccountLinkingCredential;
};

export function LoginActions({
  nonce = '',
  storedAccountLinkingCredential,
}: Props) {
  const [isAccountLinkingError, setIsAccountLinkingError] = useState(
    Boolean(storedAccountLinkingCredential)
  );
  const initialError = useGetInitialError(storedAccountLinkingCredential);
  const [error, setError] = useState(initialError);

  return (
    <>
      {error && (
        <Body variant="sm-regular" className={styles.errorText}>
          {error}
        </Body>
      )}
      <div className={styles.loginOptionsContainer}>
        <div
          className={styles.ssoLoginOptionsContainer}
          style={
            {
              '--order': isAccountLinkingError ? '3' : '1',
            } as CSSProperties
          }
        >
          <SocialLogin
            nonce={nonce}
            handleError={setError}
            setIsAccountLinkingError={setIsAccountLinkingError}
          />
        </div>
        <Divider displayOrder={2} />
        <div
          className={styles.emailLoginOptionsContainer}
          style={
            {
              '--order': isAccountLinkingError ? '1' : '3',
            } as CSSProperties
          }
        >
          <EmailMagicLinkButton type={MagicLinkType.LOGIN} />
        </div>
      </div>
    </>
  );
}
